import React, { useState, useEffect, useRef } from 'react';
import ChatBot from 'react-chatbotify';
import axios from 'axios';

const Chatbot = ({recipe, onRecipeRefresh }) => {
  const [sessionId, setSessionId] = useState(null);
  const chatbotRef = useRef(null);

  const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8095';

  useEffect(() => {
    initChatSession();
  }, []);

  const initChatSession = async () => {
    try {
      const { data } = await axios.post(
        `${API_BASE}/chat/sessions`,
        {},
        { withCredentials: true }
      );
      setSessionId(data.sessionId);
      console.log('✅ Session created:', data.sessionId);
    } catch (error) {
      console.error('❌ Session error:', error);
    }
  };

  // ✅ Simple async backend call - waits for complete response
  const callBackend = async (userMessage) => {
    console.log('📤 Sending:', userMessage);
    
    try {
      const { data } = await axios.post(
        `${API_BASE}/chat/sessions/${sessionId}/messages`,
        {
          message: userMessage,
          pageContext: { recipeId: recipe.id || null }
        },
        { withCredentials: true }
      );

      console.log('✅ Response:', data.response);
       console.log('✅ UIAction:', data.uiAction);

   if (data.uiAction === 'refresh_recipe' && onRecipeRefresh) {
      console.log('🎉 TRIGGERING REFRESH');
      onRecipeRefresh(data.recipeId);
    }


      return data.response;  // Return complete LLM response
      
    } catch (error) {
      console.error('❌ Backend error:', error);
      return "Sorry, I encountered an error processing your request. Please try again.";
    }
  };

  const flow = {
    start: {
      message: recipe 
        ? `🍳 Recipe assistant ready for ${recipe.name}\n\nWhat assistance do you need?`
        : "🍳 Recipe assistant ready!\n\nAsk me about recipes!",
      path: "chat"
    },
    chat: {
      // ✅ Intercepts user input + returns complete response
      message: async (params) => {
        const userInput = params.userInput;
        console.log('📤 User:', userInput);
        return await callBackend(userInput);
      },
      path: "chat" // Loop back to chat
    }
  };

  if (!sessionId) {
    return (
      <div style={{
        padding: '20px',
        background: '#f97316',
        color: 'white',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        🤖 Loading Recipe Assistant...
      </div>
    );
  }

  return (
   <ChatBot
  ref={chatbotRef}
  settings={{
    disableQuickReply: true,
    disableInstructions: true,
    general: { 
      embedded: true, 
      title: "Recipe Assistant",
      typingBubble: true,
      scrollTo: true,
      size: "small",
      showFooter: false
    },
    header: { 
      title: "Recipe Assistant",
      closeElement: '❌',
      showAvatar: false
    },
    chatWindow: {
      showTitle: true,
      disableTypingBubble: false,
      size: "small"
    },
    botBubble: { 
      simulateStream: true,
      animate: true, 
      streamSpeed: 5,
      size: "small"
    },
    userBubble: { 
      simulateStream: true, 
      animate: true, 
      streamSpeed: 5,
      size: "small"
    }
  }}
  styles={{
    headerStyle: {
      background: '#f8fafc',
      color: '#0f172a',
      borderBottom: '1px solid #e2e8f0',
      fontWeight: 600,
    },
    chatWindowStyle: {
      backgroundColor: '#fefefe',
      height: '100%',
      width: '100%',
    },
    botBubbleStyle: {
      backgroundColor: '#f1f5f9',
      color: '#334155',
      border: '1px solid #e2e8f0',
      borderRadius: '12px',
    },
    userBubbleStyle: {
      backgroundColor: '#f8fafc',
      color: '#1e293b',
      border: '1px solid #cbd5e1',
      borderRadius: '12px',
    },
    inputStyle: {
      backgroundColor: '#ffffff',
      border: '1px solid #d1d5db',
      borderRadius: '8px',
    },
    sendButtonStyle: {
      backgroundColor: '#64748b',
      borderColor: '#64748b',
      borderRadius: '8px',
    },
    sendButtonHoveredStyle: {
      backgroundColor: '#475569',
    },
    bodyStyle: {
      backgroundColor: '#f8fafc',
    }
  }}
  flow={flow}
/>
  );
};

export default Chatbot;